import ABCyaPhaser from "@abcya/abcya_phaser";
import GemJr from "./GemJr";

export default class Gem extends Phaser.GameObjects.Container
{
    constructor(scene, p, i, n, e)
    {
        super(scene);
        p.add(this);

        this.scene = scene;
        this.pCont = p;
        this.ind = i;
        this.randInd = n;
        this.isEnd = e;
        this.isSelected = false;
        this.adj = 0;
        this.breakType = "gem" + this.ind + "Ex";
		
        this.createGem();
    }

	createGem() {
        this.gemCont = this.scene.add.container();

        this.body = ABCyaPhaser.Images.addImage(0, 0, "emptyBtnJr", this);

        if(this.ind == 1){
            let gem = new GemJr(this.scene, this.gemCont, this.ind);
        }
        if(this.ind == 2){
            for(let i2 = 0; i2 < this.ind; i2++){
                let gem2 = new GemJr(this.scene, this.gemCont, this.ind);

                if(i2 == 0){
                    gem2.x = -25;
                    gem2.y = 20;
                }
                if(i2 == 1){
                    gem2.x = 25;
                    gem2.y = -25;
                }
            }
        }
        if(this.ind == 3){
            for(let i3 = 0; i3 < this.ind; i3++){
                let gem3 = new GemJr(this.scene, this.gemCont, this.ind);

                if(i3 == 0){
                    gem3.x = -32;
                    gem3.y = 25;
                }
                if(i3 == 1){
                    gem3.x = 2;
                    gem3.y = -3;
                }
                if(i3 == 2){
                    gem3.x = 34;
                    gem3.y = -37;
                }
            }
        }
        if(this.ind == 4){
            for(let i4 = 0; i4 < this.ind; i4++){
                let gem4 = new GemJr(this.scene, this.gemCont, this.ind);

                if(i4 == 0){
                    gem4.x = -30;
                    gem4.y = 25;
                }
                if(i4 == 1){
                    gem4.x = -30;
                    gem4.y = -33;
                }
                if(i4 == 2){
                    gem4.x = 30;
                    gem4.y = -33;
                }
                if(i4 == 3){
                    gem4.x = 30;
                    gem4.y = 25;
                }
            }
        }
        if(this.ind == 5){
            for(let i5 = 0; i5 < this.ind; i5++){
                let gem5 = new GemJr(this.scene, this.gemCont, this.ind);

                if(i5 == 0){
                    gem5.x = -35;
                    gem5.y = 30;
                }
                if(i5 == 1){
                    gem5.x = -35;
                    gem5.y = -38;
                }
                if(i5 == 2){
                    gem5.x = 35;
                    gem5.y = -38;
                }
                if(i5 == 3){
                    gem5.x = 35;
                    gem5.y = 30;
                }
                if(i5 == 4){
                    gem5.y = -3;
                }
            }
        }

        if(this.ind == 6){
            for(let i6 = 0; i6 < this.ind; i6++){
                let gem6 = new GemJr(this.scene, this.gemCont, this.ind);

                if(i6 == 0){
                    gem6.x = -28;
                    gem6.y = 33;
                }
                if(i6 == 1){
                    gem6.x = -28;
                    gem6.y = -3;
                }
                if(i6 == 2){
                    gem6.x = -28;
                    gem6.y = -40;
                }
                if(i6 == 3){
                    gem6.x = 28;
                    gem6.y = 33;
                }
                if(i6 == 4){
                    gem6.x = 28;
                    gem6.y = -3;
                }
                if(i6 == 5){
                    gem6.x = 28;
                    gem6.y = -40;
                }
            }
        }

        this.add(this.gemCont);
	};

    changeSpecial(type){
        // console.log("CREATING SPECIAL!");
        this.gemCont.removeAll(true);
        
        this.stopMovement();
        
        this.ind = type;

        for(let i5 = 0; i5 < this.ind; i5++){
            let gem5 = new GemJr(this.scene, this.gemCont, this.ind);

            if(i5 == 0){
                gem5.x = -35;
                gem5.y = 30;
            }
            if(i5 == 1){
                gem5.x = -35;
                gem5.y = -38;
            }
            if(i5 == 2){
                gem5.x = 35;
                gem5.y = -38;
            }
            if(i5 == 3){
                gem5.x = 35;
                gem5.y = 30;
            }
            if(i5 == 4){
                gem5.y = -3;
            }
        }
    };

    pulse(){
        ABCyaPhaser.Tweens.addTween(this.body, 1000, {scale:1.15, yoyo:true, repeat:-1}, Phaser.Math.Easing.Linear);
    };

    explode(){
        if(!this.body) return;
        
        let explodeTimer = 500;

        this.cloud1 = ABCyaPhaser.Images.addImage(0, 0, "cloud1", this);

        this.cloud1.angle = Phaser.Math.Between(-180, 360);
        this.cloud1.scaleX = this.cloud1.scaleY = 0;

        ABCyaPhaser.Tweens.addTween(this.cloud1, 500, {alpha:0, scale:3, angle:Phaser.Math.Between(-180, 180)}, Phaser.Math.Easing.Linear);

        this.stopMovement();
        this.body.destroy();

        ABCyaPhaser.Tweens.addTween(this, explodeTimer, {scale:2, angle:Phaser.Math.Between(-180, 180)}, Phaser.Math.Easing.Linear, ()=>{
            this.destroyGem();
        });
    };

    stopMovement(){
        if(!this.scene) return;
        //stop the creatures tweens
        
        if(this.body) this.scene.tweens.killTweensOf(this.body);
    };

    destroyGem(){
        //Destroy the gem
        //console.log("DESTROYING");
        this.stopMovement();

        // console.log(this.gemCont);
        this.gemCont?.list.forEach(gemJr => {
            gemJr.destroyGem();
        });
        this.gemCont?.removeAll(true);
        this.gemCont?.destroy();
        this.gemCont = null;

        this.removeAll(true);

        this.destroy();
    };
}